<template>
	<div class="exportReport" id="pdfPrint">

		<!-- <el-button type="primary" @click="getPdf()" class="noprint">导出监测报告PDF</el-button> -->
		<el-button type="primary" @click="convert()" class="noprint">导出监测报告图片</el-button>

		<div class="div1">{{form.recordCode}}</div>

		<div class="div2">
			<div class="div2_1">
				<div class="div2_2">
					<span>
						<img src="../assets/images/export/b1.png" alt="">
						<img src="../assets/images/export/b2.png" alt="">
					</span>
					<span></span>
					<img class="imgreport" src="../assets/images/export/b3.png" alt="">
				</div>
				<el-image style="width: 100%;" :src="tabimg.diline2" fit="contain" />
				<div class="divtitle">
					<el-image style="width: 100%;" :src="tabimg.info2" fit="contain" />
					<el-image style="width: 60px; height: 40px;margin:0px 20px 0px 10px;" :src="tabimg.dayu"
						fit="contain" />
					<el-image style="width: 100%; height:100%;" :src="tabimg.feng1" fit="contain" />
					<el-image style="width: 60px; height: 40px;margin-left:10px;" :src="tabimg.dayu" fit="contain" />
					<el-image style="width: 100%;" :src="tabimg.jian1" fit="contain" />
				</div>
			</div>
		</div>

		<div class="div3">
			<div class="div3_1">
				<el-image style="width: 100%;" :src="tabimg.diline4" fit="contain" />
				<div class="div3_2">
					<div class="touiang"></div>
					<ul>
						<li style="display: block;width:calc(100% - 100px);">
							<span>联系人</span>
							<span>{{form.name}}</span>
						</li>
						<li style="display: block;width: calc(100% - 100px);">
							<span>电话</span>
							<span style="width: calc(100% - 45px)"></span>
						</li>
						<li>
							<span>车牌</span>
							<span>{{form.plateNumber}}</span>
						</li>
						<li>
							<span>车辆厂牌</span>
							<span></span>
						</li>
						<li>
							<span>VIN</span>
							<span>{{form.vin}}</span>
						</li>
						<li>
							<span>能源类型</span>
							<span>{{form.batteryType}}</span>
						</li>
						<li>
							<span>电池笔记</span>
							<span style="width: calc(100% - 90px)"></span>
						</li>
						<li>
							<span>电池标注容量</span>
							<span style="width: calc(100% - 85px)"></span>
						</li>
						<li>
							<span>使用性质</span>
							<span style="width: calc(100% - 90px)"></span>
						</li>
						<li>
							<span>保单到期</span>
							<span></span>
						</li>
					</ul>
				</div>
				<el-image style="width: 100%;" :src="tabimg.diline3" fit="contain" />
			</div>
		</div>

		<div class="div4">
			<div class="divtitle">
				<el-image style="width: 100%;" :src="tabimg.info1" fit="contain" />
				<el-image style="width: 10%; height: 40px;margin:0px 20px 0px 10px;" :src="tabimg.dayu" fit="contain" />
				<el-image style="width: 100%; height:100%;" :src="tabimg.feng2" fit="contain" />
				<el-image style="width: 10%; height: 40px;margin-left: 10px;" :src="tabimg.dayu" fit="contain" />
				<el-image style="width: 100%;" :src="tabimg.jian1" fit="contain" />
			</div>

			<div class="div4_1">
				<el-image style="width: 100%;" :src="tabimg.diline4" fit="contain" />
				<div class="div4_2">
					<div class="div4_3">
						<span>{{form.cooling=='0'?'正常':'故障'}}</span>
						<span>{{form.score}}</span>
						<span>{{form.thermalRunaway=='0'?'正常':'故障'}}</span>
						<span>{{form.consistency}}%</span>
						<span>{{form.currentSoc}}%</span>
						<span>{{form.sot}}%</span>
						<span>{{form.capacityMetrics}}%</span>
					</div>
					<div class="div4_4">
						<div id="ech1">

						</div>
						<div id="ech2">

						</div>
						<div id="ech3">

						</div>
					</div>
				</div>
				<el-image style="width: 100%;" :src="tabimg.diline3" fit="contain" />
			</div>
		</div>

		<div class="div5">
			<div class="divtitle">
				<el-image style="width: 100%;" :src="tabimg.info1" fit="contain" />
				<el-image style="width: 10%; height: 40px;margin:0px 20px 0px 10px;" :src="tabimg.dayu" fit="contain" />
				<el-image style="width: 100%; height:100%;" :src="tabimg.feng1" fit="contain" />
				<el-image style="width: 10%; height: 40px;margin-left: 10px;" :src="tabimg.dayu" fit="contain" />
				<el-image style="width: 100%;" :src="tabimg.jian2" fit="contain" />
			</div>

			<div class="div5_1">
				<el-image style="width: 100%;" :src="tabimg.diline4" fit="contain" />
				<div class="div5_2">
					<ul>
						<li>
							<span>时间</span>
							<span>{{form.beginTime}}</span>
						</li>
						<li>
							<span>至</span>
							<span style="width: calc(100% - 45px)">{{form.endTime}}</span>
						</li>
						<li>
							<span>起始SOC</span>
							<span style="width: calc(100% - 85px)">{{form.initSoc}}</span>
						</li>
						<li>
							<span>终止SOC</span>
							<span style="width: calc(100% - 85px)">{{form.currentSoc}}</span>
						</li>
					</ul>
					<p>故障状态：</p>

					<table border>
						<tr>
							<th colspan="2">数据类型</th>
							<th>权值</th>
							<th>值格式</th>
						</tr>
						<tr v-for="items,index of tableData">
							<td :rowspan="items.rowspan" v-if="items.rowspan">{{items.name}}</td>
							<td>{{items.name1}}</td>
							<td>{{items.name2}}</td>
							<td>{{items.name3}}</td>
						</tr>
						<tr>
							<td colspan="2">电池综合健康度</td>
							<td>综合评估（必须）</td>
							<td>百分比</td>
						</tr>
					</table>
				</div>
				<p style="padding-bottom: 0px;">参考建议：</p>
				<div class="div5_3">
					<textarea name="" id="" style="width: 100%;height: 180px;"></textarea>
				</div>
				<el-image style="width: 100%;" :src="tabimg.diline3" fit="contain" />
			</div>
		</div>



	</div>
</template>

<script>
	import html2Canvas from 'html2canvas';
	import { saveAs } from 'file-saver'
	
	import JsPDF from 'jspdf';
	import 'echarts-liquidfill'

	export default {
		props: ['pileCode', 'recordCode', 'formPrint'],
		data() {
			return {
				pileCodeStr: '',
				recordCodeStr: '',
				AuthorizationStr: '',
				form: {},

				tabimg: {
					info1: require('../assets/images/export/info1.png'),
					info2: require('../assets/images/export/info2.png'),
					feng1: require('../assets/images/export/fen1.png'),
					feng2: require('../assets/images/export/fen2.png'),
					jian1: require('../assets/images/export/jian1.png'),
					jian2: require('../assets/images/export/jian2.png'),
					dayu: require('../assets/images/export/dayu.png'),
					diline2: require('../assets/images/export/a2.png'),
					diline3: require('../assets/images/export/a3.png'),
					diline4: require('../assets/images/export/a4.png'),
				},

				tableData: [{
					name: '健康指标',
					name1: 'SOH',
					name2: '重要指标（必须）',
					name3: '百分比',
					rowspan: 4,
				}, {
					name: '健康指标',
					name1: 'SOE',
					name2: '重要指标（必须）',
					name3: '百分比',
				}, {
					name: '健康指标',
					name1: 'SOT',
					name2: '重要指标（必须）',
					name3: '百分比',
				}, {
					name: '健康指标',
					name1: '一致性',
					name2: '重要指标（必须）',
					name3: '百分比',
				}, {
					name: '安全指标',
					name1: '热失控',
					name2: '重要指标（必须）',
					name3: '等级',
					rowspan: 3,
				}, {
					name: '安全指标',
					name1: '冷却系统',
					name2: '重要指标（必须）',
					name3: '等级',
				}, {
					name: '安全指标',
					name1: '气密性',
					name2: '重要指标（必须）',
					name3: '等级',
				}, {
					name: '过程异常监测指标',
					name1: '停充原因',
					name2: '过程监测（可选）',
					name3: '正常/故障',
					rowspan: 23,
				}, {
					name: '过程异常监测指标',
					name1: '最大SOC变化率',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '电池最大温差',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '电池最大温升速率',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '电池最高温度',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '单体最高电压',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '最高充电电压',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '电池最大压差',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '最高充电电流',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '电池剩余容量百分比',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '需求电压超过最大允许电压',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '需求电流超过最大允许电流',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '充电过流',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '电池整包过压',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '充电机输出电压超差',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '充电机输出电流超差',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '充电SOC超范围',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '电池不均衡',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: 'gus',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '最高温度异常',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '最大温差异常',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '电池压差异常',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}, {
					name: '过程异常监测指标',
					name1: '单体最高电压异常',
					name2: '过程监测（可选）',
					name3: '正常/故障',
				}],

			}
		},
		mounted() {
			let _this = this;
			var query = this.$route.query;
			_this.pileCodeStr = query.pileCode;
			_this.recordCodeStr = query.recordCode;
			_this.AuthorizationStr = query.Authorization;
			if (JSON.stringify(query) != '{}') {
				_this.onReportPreview();
			}

			this.$nextTick(() => {})
		},
		methods: {
			convert: function() {
				html2Canvas(document.querySelector('#pdfPrint'), { 
					allowTaint: true
				}).then(function(canvas) {
					canvas.toBlob(function(blob) {
						saveAs(blob, "监测报告图片.png");
					});
				})
				
			},

			// 车检报告预览数据
			onReportPreview: function() {
				let _this = this;
				this.$api.post('/order/report/preview', {
						pileCode: _this.pileCode == undefined ? _this.pileCodeStr : _this.pileCode, //充电桩编号
						recordCode: _this.recordCode == undefined ? _this.recordCodeStr : _this.recordCode, //订单编号
					},
					function(response, context) {
						if (response.code == "200") {
							_this.onformat(response.data);
						}
					}
				);
			},


			onRadar: function() {
				let _this = this;
				_this.radarchart1 = this.$echarts.init(document.getElementById('ech1'));
				var indicator = [{
						name: '电压',
						max: 100,
						num: 1
					},
					{
						name: '内阻',
						max: 100,
						num: 2
					},
					{
						name: '容量',
						max: 100,
						num: 3
					},
					{
						name: '电量',
						max: 100,
						num: 4
					},
					{
						name: '温度',
						max: 100,
						num: 5
					},
				];
				var dataValue = [0, 0, 0, 0, 0]
				var dataArr = [{
					value: dataValue,
					name: '',
					itemStyle: {
						normal: {
							lineStyle: {
								color: '#17E7FF',
							},
							shadowColor: '#17E7FF',
							shadowBlur: 5,
						},
					}
				}];

				function contains(arr, obj) {
					var i = arr.length;
					while (i--) {
						if (arr[i].name === obj) {
							return i;
						}
					}
					return false;
				}
				var num = 80;
				var option = {
					title: {
						text: '一致性分析得分',
						left: 'center',
						textVerticalAlign: 'middle',
						bottom: '-10',
						textStyle: {
							color: '#d8d8d8',
							fontSize: 12,
						}
					},
					color: ['#17E7FF'],
					radar: {
						radius: '70%',
						center: ['50%', '55%'],
						triggerEvent: true, //开启雷达图的边角名称可点击
						name: {
							textStyle: {
								padding: [10, 10, 0, 10],
							},
							formatter: (value) => {
								let i = contains(indicator, value); // 处理对应要显示的样式
								return '{a|' + dataValue[i] + '}\n' + '{b|' + value + '}';
							},
							rich: {
								a: {
									align: 'center',
									color: '#6EFFFD',
									fontWeight: 500,
									fontSize: 16,
								},
								b: {
									align: 'center',
									color: '#FFFFFF',
									fontSize: 10,
								},
								// triggerEvent: true,//开启雷达图的边角名称可点击
							},
						},

						nameGap: 8,
						indicator: indicator,
						splitArea: {
							// 坐标轴在 grid 区域中的分隔区域，默认不显示。
							show: false,
						},
						axisLine: {
							//轴线
							show: true,
							lineStyle: {
								color: this.$echarts.graphic.RadialGradient(0.5, 0.5, 1, [{
										color: '#15506D0D',
										offset: 0,
									},
									{
										color: '#95E4F0',
										offset: 0.9,
									},
								]),
							},
						},
						splitLine: {
							show: true,
							lineStyle: {
								width: 1,
								color: 'rgba(153, 209, 246, 0.5)', // 网格分割线颜色
							},
						},
					},
					series: [{
						type: 'radar',
						symbolSize: 8,
						symbol: 'circle',
						data: dataArr,
						areaStyle: {
							color: '#9EDDFF',
							opacity: 0.3,
						},
						lineStyle: {
							color: this.$echarts.graphic.LinearGradient(
								0,
								0,
								0,
								1,
								[{
										offset: 0,
										color: '#00D1FF',
									},
									{
										offset: 1,
										color: '#00A5FE',
									},
								],
								false
							),
							width: 3,
						},
						itemStyle: {
							color: '#fff ',
							borderColor: this.$echarts.graphic.LinearGradient(
								0,
								0,
								0,
								1,
								[{
										offset: 0,
										color: '#00D1FF',
									},
									{
										offset: 1,
										color: '#00A5FE',
									},
								],
								false
							),
							borderWidth: 2,
							opacity: 1,
						}
					}],
				};

				_this.radarchart1.setOption(option, true);
				window.addEventListener("resize", function() {
					_this.radarchart1.resize();
				});
				var imgSrc = _this.radarchart1.getDataURL();
				$('#radarimg').attr('src', imgSrc).show();
				$('#radarimg').css('display', 'none');
			},
			onRadar2: function() {
				let _this = this;
				_this.radarchart2 = this.$echarts.init(document.getElementById('ech2'));
				var dataArr = _this.form.capacityMetrics;
				let angle = 0; //角度，用来做简单的动画效果的
				let maxScore = 100,
					scoresPercentage = dataArr / maxScore;

				var option = {
					title: {
						text: '容量特性分析得分',
						left: 'center',
						textVerticalAlign: 'middle',
						bottom: '-10',
						textStyle: {
							color: '#d8d8d8',
							fontSize: 12,
						}
					},

					series: [{
							name: '内部进度条',
							type: 'gauge',
							center: ['50%', '55%'],
							radius: '80%',
							z: 1,
							startAngle: 225,
							endAngle: -45,
							splitNumber: 5,
							progress: {
								show: true,
								width: 20,
								itemStyle: {
									color: {
										type: 'linear',
										x: 0,
										y: 1,
										x2: 0,
										y2: 0,
										colorStops: [{
												offset: 0,
												color: '#3889E3',
											},
											{
												offset: 0.5,
												color: '#3889E3',
											},
											{
												offset: 1,
												color: '#3889E3',
											},
										],
										global: false, // 缺省为 false
									},
								},
							},
							axisLine: {
								lineStyle: {
									color: [
										[1, 'rgba(0, 170, 255, 0.1)']
									],
									width: 20,
								},
							},
							axisLabel: {
								show: true,
								color: 'rgba(240,240,240,0.5)',
								fontSize: 12,
								distance: -10,
								formatter: function(value, index) {

									if (value == 0 || value == 100) {
										return value
									}
								}
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							itemStyle: {
								show: false,
							},
							detail: {
								offsetCenter: [0, '-10%'],
								textStyle: {
									padding: [0, 0, 0, 0],
									fontSize: 24,

									color: 'rgba(240,240,240,1)',
								},
							},
							title: {
								show: true,
								offsetCenter: [0, '15%'],
								textStyle: {
									color: 'rgba(240,240,240,1)',
									fontSize: 12,
									fontFamily: 'PingFangSC',
								},
							},
							data: [{
								name: '分',
								value: dataArr,
							}],
							pointer: {
								show: false,
								length: '75%',
								width: 5,
								itemStyle: {
									color: 'rgba(16,235,227,1)',
								},
							},
						},
						{
							name: '刻度',
							type: 'gauge',
							center: ['50%', '55%'],
							radius: '70%',
							startAngle: 225,
							endAngle: -45,
							splitNumber: 5,
							progress: {
								show: false,
							},
							axisLine: {
								show: false,
								lineStyle: {
									width: 27,
								},
							},
							//仪表盘轴线
							axisLabel: {
								show: false,
							}, //刻度标签。
							axisTick: {
								show: false,
								splitNumber: 3,
								lineStyle: {
									color: 'rgba(16,235,227,0.2)',
									width: 2,
								},
								length: 2,
								distance: -15
							},
							splitLine: {
								show: false,
								length: 10,
								lineStyle: {
									color: 'rgba(16,235,227,1)',
									width: 2,
								},
								distance: -17
							},
							itemStyle: {
								show: false,
							},
							detail: {
								show: false,
							},
							title: {
								//标题
								show: false,
							},

							pointer: {
								show: false,
							},
						},
						{
							name: '最内边线',
							type: 'gauge',
							center: ['50%', '55%'],
							radius: '48%',
							z: 999,
							startAngle: 225,
							endAngle: -45,
							splitNumber: 5,
							progress: {
								show: false,
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 1,
									color: [
										[1, 'rgba(0,255,239,0.2)']
									],
								},
							},
							axisLabel: {
								show: false,
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							itemStyle: {
								show: false,
							},
							detail: {
								show: false,
							},
							title: {
								show: false,
							},

							pointer: {
								show: false,
							},
						},
						{
							name: '最外刻度亮线',
							type: 'gauge',
							radius: '80%',
							center: ['50%', '55%'],
							startAngle: 225 - (270 * dataArr) / 100 + 1,
							endAngle: 225 - (270 * dataArr) / 100 - 30,
							splitNumber: 10,
							axisLine: {
								show: true,
								lineStyle: {
									color: [
										[3 / 100, 'rgba(0,0,0,0)'],
									],
									width: 29,
									shadowColor: 'rgba(16,235,227,1)',
									shadowBlur: 10,
								},
							},
							progress: {
								show: true,
								width: 18,
								itemStyle: {
									color: '#10EBE3',
									shadowColor: 'rgba(16,235,227,1)',
									shadowBlur: 10,
								},
							},
							axisLabel: {
								show: false,
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							detail: {
								show: false,
							},
							pointer: {
								show: false,
							},
							animationDelay: 850,
							animationDuration: 300,
							data: [{
								name: 'title',
								value: 100,
							}, ],
							title: {
								show: false,
							},
						},
						{
							type: 'gauge',
							radius: '90%',
							center: ['50%', '55%'],
							z: 9998,
							min: 0,
							max: 100,
							startAngle: 225,
							endAngle: -45,
							pointer: {
								show: false,
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 35,
									color: [
										[0.25, '#0F2870'],
										[0.5, '#0F2870'],
										[0.75, '#0F2870'],
										[1, '#0F2870'],
									],
									opacity: 0.1,
									borderColor: '#000',
									borderWidth: '10',
								},
							},
							axisLabel: {
								show: false,
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							detail: {
								show: false,
							},
							title: {
								show: false,
							},
							data: [dataArr],
						},
						// 仪表盘值得渐变
						{
							type: 'pie',
							zlevel: 10,
							radius: ['90%', '92%'],
							center: ['50%', '55%'],
							silent: true,
							startAngle: 225,
							endAngle: 45,
							label: {
								show: false,
							},
							labelLine: {
								show: false,
							},
							data: [{
									name: '',
									value: scoresPercentage,
									itemStyle: {
										color: {
											x: 0,
											y: 0,
											x2: 1,
											y2: 0,
											type: 'linear',
											global: false,
											colorStops: [{
													offset: 0,
													color: 'rgba(13,49,118,0.1)',
												},
												{
													offset: 1,
													color: '#00FFEF',
												},
											],
										},
									},
								},
								{
									value: 1.325 - scoresPercentage,
									itemStyle: {
										opacity: 0,
										color: 'rgba(255, 255, 255, 0)',
									},
								},
							],
						},

						// 值得尾巴，那个圆圈
						{
							type: 'pie',
							radius: ['87%', '88%'],
							center: ['50%', '55%'],
							zlevel: 10,
							silent: true,
							startAngle: 225,
							endAngle: 45,
							data: [{
									name: '',
									value: scoresPercentage,
									label: {
										show: false,
									},
									labelLine: {
										show: false,
									},
									itemStyle: {
										color: 'rgba(0,0,0,0)',
									},
								},

								// 画中间的图标
								{
									name: '',
									value: 0,
									label: {
										position: 'inside',
										backgroundColor: '#00FFF2',
										borderRadius: 12,
										padding: 3, // 可以控制圆的大小
										borderWidth: 3,
										borderColor: 'rgba(0,255,239,0.8)',
									},
								},
								{
									name: '',
									value: 1.325 - scoresPercentage,
									label: {
										show: false,
									},
									labelLine: {
										show: false,
									},
									itemStyle: {
										color: 'rgba(255,255,255,0)',
									},
								},
							],
						},

					],
				};


				_this.radarchart2.setOption(option);
				window.addEventListener("resize", function() {
					_this.radarchart2.resize();
				});
				var imgSrc = _this.radarchart2.getDataURL();
				$('#radar2img').attr('src', imgSrc).show();
				$('#radar2img').css('display', 'none');
				setTimeout(function() {
					var imgSrc = _this.radarchart2.getDataURL();
					$('#radar2img').attr('src', imgSrc).show();
					$('#radar2img').css('display', 'none');
				}, 2000);

			},
			onRadar3: function() {
				let _this = this;
				_this.radarchart3 = this.$echarts.init(document.getElementById('ech3'));

				var dataArr = _this.form.energyIndicator;
				let maxScore = 100,
					scoresPercentage = dataArr / maxScore;

				var colorList = [{
					x: 0,
					y: 1,
					x2: 0,
					y2: 0,
					colorStops: [{
						offset: 0,
						color: '#38B2E3' // 0% 处的颜色
					}, {
						offset: 1,
						color: '#38B2E3' // 100% 处的颜色
					}],
				}, {
					x: 0,
					y: 1,
					x2: 0,
					y2: 0,
					colorStops: [{
						offset: 0,
						color: '#32E1D5' // 0% 处的颜色
					}, {
						offset: 1,
						color: '#32E1D5' // 100% 处的颜色
					}],
				}, {
					x: 0,
					y: 1,
					x2: 0,
					y2: 0,
					colorStops: [{
						offset: 0,
						color: '#FFC16D' // 0% 处的颜色
					}, {
						offset: 1,
						color: '#FFC16D' // 100% 处的颜色
					}],
				}];

				var option = {
					title: {
						text: '能量特性分析得分',
						left: 'center',
						textVerticalAlign: 'middle',
						bottom: '-10',
						textStyle: {
							color: '#d8d8d8',
							fontSize: 12,
						}
					},

					series: [{
							type: 'gauge',
							splitNumber: 3,
							center: ['50%', '55%'],
							radius: '80%',
							startAngle: 225,
							endAngle: -45,
							min: 0,
							max: 100,
							pointer: {
								show: false,
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 20,
									color: [
										[0.33, colorList[0]],
										[0.66, colorList[1]],
										[1, colorList[2]],
									],
									borderColor: '#000',
									borderWidth: '10',
								},
							},
							axisLabel: {
								show: true,
								color: 'rgba(240,240,240,0.5)',
								fontSize: 12,
								distance: -20,
								formatter: function(value, index) {

									if (value == 0 || value == 100) {
										return value
									}
								}
							},
							axisTick: {
								show: false,

							}, //刻度样式            
							splitLine: {
								show: false,
								length: "28%",
								lineStyle: {
									color: "#fff",
									width: 2,
								},
							}, //分隔线样式

							detail: {
								offsetCenter: [0, '-10%'],
								textStyle: {
									padding: [0, 0, 0, 0],
									fontSize: 24,

									color: 'rgba(240,240,240,1)',
								},
							},
							title: {
								show: true,
								offsetCenter: [0, '15%'],
								textStyle: {
									color: 'rgba(240,240,240,1)',
									fontSize: 12,
									fontFamily: 'PingFangSC',
								},
							},
							data: [{
								name: '分',
								value: dataArr,
							}],

						},
						{
							name: '最内边线',
							type: 'gauge',
							center: ['50%', '55%'],
							radius: '48%',
							z: 999,
							startAngle: 225,
							endAngle: -45,
							splitNumber: 5,
							progress: {
								show: false,
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 1,
									color: [
										[1, 'rgba(0,255,239,0.2)']
									],
								},
							},
							axisLabel: {
								show: false,
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							itemStyle: {
								show: false,
							},
							detail: {
								show: false,
							},
							title: {
								show: false,
							},

							pointer: {
								show: false,
							},
						},
						{
							type: 'gauge',
							radius: '90%',
							center: ['50%', '55%'],
							z: 9998,
							min: 0,
							max: 100,
							startAngle: 225,
							endAngle: -45,
							pointer: {
								show: false,
							},
							axisLine: {
								show: true,
								lineStyle: {
									width: 35,
									color: [
										[0.25, '#0F2870'],
										[0.5, '#0F2870'],
										[0.75, '#0F2870'],
										[1, '#0F2870'],
									],
									opacity: 0.1,
									borderColor: '#000',
									borderWidth: '10',
								},
							},
							axisLabel: {
								show: false,
							},
							axisTick: {
								show: false,
							},
							splitLine: {
								show: false,
							},
							detail: {
								show: false,
							},
							title: {
								show: false,
							},
							data: [dataArr],
						},

						// 仪表盘值得渐变
						{
							type: 'pie',
							zlevel: 10,
							radius: ['90%', '92%'],
							center: ['50%', '55%'],
							silent: true,
							startAngle: 225,
							endAngle: 45,
							label: {
								show: false,
							},
							labelLine: {
								show: false,
							},
							data: [{
									name: '',
									value: scoresPercentage,
									itemStyle: {
										color: {
											x: 0,
											y: 0,
											x2: 1,
											y2: 0,
											type: 'linear',
											global: false,
											colorStops: [{
													offset: 0,
													color: 'rgba(13,49,118,0.1)',
												},
												{
													offset: 1,
													color: '#00FFEF',
												},
											],
										},
									},
								},
								{
									value: 1.325 - scoresPercentage,
									itemStyle: {
										opacity: 0,
										color: 'rgba(255, 255, 255, 0)',
									},
								},
							],
						},

						// 值得尾巴，那个圆圈
						{
							type: 'pie',
							radius: ['87%', '88%'],
							center: ['50%', '55%'],
							zlevel: 10,
							silent: true,
							startAngle: 225,
							endAngle: 45,
							data: [{
									name: '',
									value: scoresPercentage,
									label: {
										show: false,
									},
									labelLine: {
										show: false,
									},
									itemStyle: {
										color: 'rgba(0,0,0,0)',
									},
								},

								// 画中间的图标
								{
									name: '',
									value: 0,
									label: {
										position: 'inside',
										backgroundColor: '#00FFF2',
										borderRadius: 12,
										padding: 3, // 可以控制圆的大小
										borderWidth: 3,
										borderColor: 'rgba(0,255,239,0.8)',
									},
								},
								{
									name: '',
									value: 1.325 - scoresPercentage,
									label: {
										show: false,
									},
									labelLine: {
										show: false,
									},
									itemStyle: {
										color: 'rgba(255,255,255,0)',
									},
								},
							],
						},
					]
				};

				_this.radarchart3.setOption(option);
				window.addEventListener("resize", function() {
					_this.radarchart3.resize();
				});
				var imgSrc = _this.radarchart3.getDataURL();
				$('#radar3img').attr('src', imgSrc).show();
				$('#radar3img').css('display', 'none');
				setTimeout(function() {
					var imgSrc = _this.radarchart3.getDataURL();
					$('#radar3img').attr('src', imgSrc).show();
					$('#radar3img').css('display', 'none');
				}, 2000);
			},



			onformat: function(data) {
				let _this = this;
				_this.form = {
					recordCode: data.recordCode,
					stationName: data.stationName,
					gunNo: data.gunNo,
					pileCode: data.pileCode,
					beginTime: data.beginTime,
					endTime: data.endTime,
					plateNumber: data.plateNumber,
					carType: data.carType,
					vin: data.vin,
					batteryType: data.batteryType,
					score: data.score,
					suggest: data.suggest,
					consistency: data.consistency,
					capacityMetrics: data.capacityMetrics,
					energyIndicator: data.energyIndicator,
					thermalRunaway: data.thermalRunaway,
					failureMetrics: data.failureMetrics,
					cooling: data.cooling,
					currentSoc: data.currentSoc,
					initSoc: data.initSoc,
					sot: data.sot
				};


				this.$nextTick(() => {

					_this.onRadar();
					_this.onRadar2();
					_this.onRadar3();
				})

			},

			getPdf() {
				var title = '报告_' + new Date().toLocaleString(); // 导出的pdf文件名
				html2Canvas(document.querySelector('#pdfPrint'), { //导出的html元素
					allowTaint: true
				}).then(function(canvas) {
					let contentWidth = canvas.width;
					let contentHeight = canvas.height;
					let pageHeight = contentWidth / 592.28 * 841.89;
					let leftHeight = contentHeight;
					let position = 0;
					let imgWidth = 595.28;
					let imgHeight = 592.28 / contentWidth * contentHeight;
					let pageData = canvas.toDataURL('image/jpeg', 1.0);
					let PDF = new JsPDF('', 'pt', 'a4');

					if (leftHeight < pageHeight) {
						PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgWidth);
					} else {
						while (leftHeight > 0) {
							PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
							leftHeight -= pageHeight;
							position -= 841.89;
							if (leftHeight > 0) {
								PDF.addPage();
							}
						}
					}
					PDF.save(title + '.pdf');
				})
			},

		},
		watch: {
			formPrint: function(newValue, oldValue) {
				console.log("formPrint:", newValue);

				this.onformat(newValue);

				this.$emit('feedback', '200', '2');
			},
		}
	}
</script>

<style lang="scss">
	html,
	body,
	#app {
		height: max-content !important;
		background: #ffffff;
		-webkit-print-color-adjust: exact;
		-ms-overflow: scroll;
		-ms-overflow-style: none;
	}

	.main {
		// background-color: #14266E !important;
	}

	@media print {
		#app {
			// background-color: #14266E !important;
		}

		.noprint {
			display: none;
			background-color: white !important;
		}
	}


	.exportReport {
		margin: auto;
		width: 100%;
		max-width: 1100px;
		background-color: #13266E;
		color: rgba(255, 255, 255, 0.8);
		font-size: 14px;

		.noprint {
			position: fixed;
			right: 10%;
			top: 50%;
			z-index: 99999;
		}

		.divtitle {
			width: 100%;
			height: 100px;
			display: flex;
			justify-content: space-evenly;
			align-items: center;
		}

		.div1 {
			line-height: 40px;
			padding: 10px 40px;
			font-weight: bold;
			font-family: fangsong;
			letter-spacing: 3px;
			font-size: 24px;
			text-align: right;
			color: #92ABFF;
			background-image: url("../assets/images/export/a1.png");
			background-repeat: no-repeat;
			background-size: auto 30px;
			background-position: 40px;
			background-color: #19388F;
		}

		.div2 {
			width: 100%;
			height: auto;

			.div2_1 {
				background-image: url("../assets/images/export/b5.png");
				background-repeat: no-repeat;
				background-size: 200px 200px;
				background-position: 0 100px;
				height: 100%;
				width: 100%;
				padding: 20px;

				.div2_2 {
					background-image: url("../assets/images/export/b4.png");
					background-repeat: no-repeat;
					background-size: 100% 100%;
					width: 100%;
					height: 150px;
					margin: auto;
					display: flex;
					justify-content: space-evenly;
					margin-bottom: 20px;

					span {
						&:nth-child(1) {
							width: 50%;
							padding: 20px 0px 20px 40px;

							img {
								&:nth-child(1) {
									width: 280px;
									height: auto;
								}

								&:nth-child(2) {
									width: 280px;
									height: auto;
								}
							}
						}

						&:nth-child(2) {
							width: 50%;
							background-image: url("../assets/images/export/a1.png");
							background-repeat: no-repeat;
							background-size: auto 30px;
							background-position: center 80px;
						}
					}

					.imgreport {
						height: 200px;
						margin-top: -25px;
					}
				}

			}


		}

		.div3 {
			width: 100%;
			height: auto;
			background-image: url('../assets/images/export/c1.png');
			background-repeat: no-repeat;
			background-size: 200px auto;
			padding: 0px 20px 0px 20px;

			.div3_1 {
				background-image: url('../assets/images/export/c3.png');
				background-repeat: no-repeat;
				width: 100%;
				height: 100%;
				padding: 10px 20px 10px 20px;

				.div3_2 {
					background-image: url('../assets/images/export/c2.png');
					background-repeat: no-repeat;
					background-size: 100% 100%;
					width: 90%;
					height: auto;
					margin: auto;
					position: relative;

					.touiang {
						width: 80px;
						height: 80px;
						border-radius: 5px;
						background-color: #133288;
						position: absolute;
						right: 40px;
						top: 40px;
					}

					ul {
						padding: 0px 40px 10px;
						margin: 0px;

						li {
							display: inline-block;
							width: 50%;
							margin-bottom: 10px;

							span {
								display: inline-block;

								&:nth-child(1) {
									margin-right: 5px;
								}

								&:nth-child(2) {
									border-bottom: 1px solid rgb(255 255 255 / 10%);
									display: inline-block;
									width: calc(100% - 60px);
									height: 20px;
									padding-left: 20px;
									line-height: 16px;
									font-size: 16px;
									color: white;
								}
							}

						}
					}
				}
			}
		}

		.div4 {
			width: 100%;
			height: auto;
			background-image: url('../assets/images/export/d1.png');
			background-repeat: no-repeat;
			background-size: 250px auto;
			padding: 20px;
			background-position: left 100px;

			.div4_1 {
				background-image: url('../assets/images/export/c3.png');
				background-repeat: no-repeat;
				width: 100%;
				height: 100%;
				padding: 10px 20px 10px 20px;
				margin-top: 20px;

				.div4_2 {
					background-image: url('../assets/images/export/c2.png');
					background-repeat: no-repeat;
					background-size: 100% 100%;
					width: 90%;
					height: auto;
					margin: auto;
					position: relative;
					padding: 10px 0px 20px;

					.div4_3 {

						background-image: url('../assets/images/export/d2.png');
						background-repeat: no-repeat;
						background-size: 90% 180px;
						background-position: center 50px;
						height: 250px;
						width: 100%;
						position: relative;
						margin-bottom: 10px;

						span {
							display: block;
							width: 100px;
							height: 100px;
							position: absolute;
							font-weight: bold;
							text-align: center;
							font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;

							background-size: 100% 100%;
							background-repeat: no-repeat;
							width: 110px;
							height: 90px;
							margin: auto;
							line-height: 80px;
							font-size: 1.8rem;

							&:nth-child(1) {
								background-image: url('../assets/images/export/d6.png');
								top: 0px;
								left: 25%;
								font-size: 1.2rem;
							}

							&:nth-child(2) {
								background-image: url('../assets/images/export/d3.png');
								background-size: 100% 100%;
								background-repeat: no-repeat;
								width: 120px;
								height: 120px;
								margin: auto;
								top: 0px;
								left: 0px;
								right: 0px;
								font-size: 2.5rem;
								line-height: 90px;
							}

							&:nth-child(3) {
								background-image: url('../assets/images/export/d4.png');
								top: 0px;
								right: 25%;
								font-size: 1.2rem;
							}

							&:nth-child(4) {
								background-image: url('../assets/images/export/d5.png');
								top: 35%;
								right: 10%;
							}

							&:nth-child(5) {
								background-image: url('../assets/images/export/d7.png');
								bottom: 0px;
								right: 30%;
							}

							&:nth-child(6) {
								background-image: url('../assets/images/export/d9.png');
								bottom: 0px;
								left: 30%;
							}

							&:nth-child(7) {
								background-image: url('../assets/images/export/d8.png');
								bottom: 25%;
								left: 10%;
							}
						}
					}

					.div4_4 {
						display: flex;
						justify-content: space-evenly;

						div {
							width: 30%;
							height: 200px;
						}
					}
				}
			}
		}

		.div5 {
			width: 100%;
			height: auto;
			padding: 20px;
			background-position: left 100px;

			.div5_1 {
				margin-top: 20px;
				background-image: url('../assets/images/export/e2.png');
				background-repeat: no-repeat;
				background-size: 100% 100%;
				width: 100%;
				height: auto;
				padding: 30px;

				.div5_2 {
					background-image: url('../assets/images/export/e1.png');
					background-repeat: no-repeat;
					background-size: 100% auto;
					width: 100%;
					height: auto;
					padding: 20px;
					margin-bottom: 40px;

					ul {
						padding: 20px 20px 0px 30px;
						margin: 0px;

						li {
							display: inline-block;
							width: 50%;
							margin-bottom: 10px;

							span {
								display: inline-block;

								&:nth-child(1) {
									margin-right: 5px;
								}

								&:nth-child(2) {
									border-bottom: 1px solid rgb(255 255 255 / 10%);
									display: inline-block;
									width: calc(100% - 60px);
									height: 20px;
									padding-left: 20px;
									font-size: 16px;
									line-height: 14px;
									color: white;
								}
							}

						}
					}

					table {
						width: 100%;
						margin: auto;
						text-align: center;
						border-color: #9093993d;

						th {
							line-height: 40px;
							background-color: #1A3895;
						}

						td {
							line-height: 32px;
						}

						tr:nth-child(odd) {
							background-color: #1A3895;
						}

						tr:nth-child(even) {
							background-color: #113296;
						}

						tr {

							&:nth-child(2),
							&:nth-child(6),
							&:nth-child(9),
							&:nth-child(32) {
								td:nth-child(1) {
									background-color: #0F2B84;
									writing-mode: vertical-lr;
									padding: 20px;
								}
							}

							&:nth-child(32) td {
								writing-mode: initial !important;
								padding: 0px !important;
								line-height: 35px !important;
							}
						}

					}

				}

				.div5_3 {
					background-image: url('../assets/images/export/e3.png');
					background-repeat: no-repeat;
					background-size: 100% 100%;
					width: 100%;
					height: 300px;
					margin: 20px 0px;
					padding: 60px 100px 60px 130px;

					textarea {
						background-color: transparent;
						border-width: 0px;
						color: white;
					}
				}

				p {
					font-weight: bold;
					margin: 0px;
					padding: 10px 20px 10px;
					color: white;
				}
			}
		}

	}
</style>